<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'
// eslint-disable-next-line import/extensions
import { useSocket } from '@/hooks/useSocket.ts'
import { EChartUtils } from '@/utils/eChartUtils'
import { useUserStore } from '@/store'

// 用户信息
const userStore = useUserStore()

onLaunch(() => {
  console.log('App Launch')
  useSocket().connect()
  const chartsX: string[] = EChartUtils.generateTimeLabels()
  uni.setStorageSync('CHARTS_X', JSON.stringify(chartsX))
})
onShow(() => {
  if (userStore.accessToken) {
    userStore.setUserInfo()
  }
  console.log('App Show')
})
onHide(() => {
  console.log('App Hide')
})
</script>

<style lang="scss">
@import '@/uni_modules/uv-ui-tools/index.scss';
/* stylelint-disable selector-type-no-unknown */
button::after {
  border: none;
}

swiper,
scroll-view {
  flex: 1;
  height: 100%;
  overflow: hidden;
}

image {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
